<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar dense class="toolbar" flat color="white">
                <v-toolbar-title>Online Outstanding Fees Payment</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>

            <v-row justify="center">
                <v-col cols="12" sm="4" md="4">
                    <v-combobox color="#0f2027" rounded v-model="selected_children" :items="children" label="Select Child" item-text="name" outlined dense prepend-icon="mdi-account-child-circle" @click="show = false"></v-combobox>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                    <v-btn class="button" @click="getDetails()">Proceed</v-btn>
                </v-col>
            </v-row>
            <span v-if="show == true">
                <student-outstanding-fees  :selected_children="selected_children"></student-outstanding-fees>  
             </span>
        </v-card>
    </div>
</template>
<script>
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    import StudentOutstandingFeeBillDesk from "../Parent/StudentOutstandingFeeBillDesk";
    import axios from "axios";
    export default {
         name: "StudentOutstandingFees",
        components: {
            "student-outstanding-fees":StudentOutstandingFeeBillDesk,
        },
        data: () => ({
            child_info: null,
            children: [],
            selected_install: [],
            get_component_installmet_list: [],
            show: false,
            selected_children: "",
            child_notice: null,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            loader: true,
            current_ay: "",
             leaner_div:null,
            leaner_std:null,
            search: "",
            s3url: "",
            misc_fees_list:"",
            url:"",
            student_outstanding_fees_list: [],
            payment_modes: [],
            select_mode: "",
            new_input: "",
            student_receipts:[],
            headers: [
                { text: "Sr. No.", value: "srno" },
                { text: "PRN No.", value: "stud_reg_no", align: "center" },
                { text: "Academic Year", value: "of_academicyear" },
                { text: "Fees", value: "fee" },
                { text: "Paid Fees", value: "paid_fee" },
                { text: "Balance", value: "balance" },
                { text: "Amount", value: "pay_fee" },
                { text: "Pay", value: "action", align: "center" },
            ],
        }),
         created(){
         this.url=process.env.VUE_APP_API_URL + "/paymentGatewayPayTM/paytm_outstanding"
    },
        methods: {
                payment(){
               var formData = new FormData(paytmform);
               console.log("formData")
               console.log(formData)
               this.loader= false
            },
            getDetails() {
                const formData = {
                    registration_no: this.selected_children.registration_number,
                };
                this.overlay = true;
                axios
                    .post("OutstandingFees/getLearnerData", formData)
                    .then((res) => {
                        this.overlay = false;
                        if (res.data.flag == "YES") {
                             this.show = true;
                            this.student_outstanding_fees_list = res.data.array_of_sof;
                            this.payment_modes = res.data.payment_modes;
                            this.student_receipts = res.data.student_receipts
                             this.current_ay = res.data.current_ay;
                            this.leaner_std = res.data.leaner_std;
                            this.leaner_div = res.data.leaner_div;
                        }
                        if (res.data.flag == "NO") {
                            this.showSnackbar("#b71c1c", res.data.snackbar);
                            return;
                        }
                    })
                    .catch((error) => {
                        this.overlay = false;
                        window.console.log(error);
                        this.showSnackbar("#b71c1c", "Something Went Wrong");
                    })
                    .finally(() => {
                        this.overlay = false;
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },

        mounted() {
            //alert("this.s3url::"+this.s3url)
            axios
                .post("/AccountingAndFees/getChildList")
                .then((res) => {
                    if (res.data.msg == "200") {
                        if ((res.data.status = "SUCCESS")) {
                            this.children = res.data.learners;
                        } else {
                            alert(res.data.status_reason);
                        }
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                })
                .finally(() => {
                    //close loader
                    this.loader = false;
                    //alert("done")
                });
        },
    };
</script>

<style scoped>
    .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
    .text{
   color: red !important;
}
</style>
